
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function RegisterButton({ className }) {
  const navigate = useNavigate();
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const [hasProfile, setHasProfile] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkProfile = async () => {
      if (!user?.email) {
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(
          `https://agepcoatings.com/getuserregisterprofile/${user.email}`
        );

        if (res.ok) {
          const data = await res.json();
          if (data.success && data.data) {
            setHasProfile(true); // ✅ Profile exists
          }
        }
      } catch (err) {
        console.error("❌ Error checking profile:", err);
      } finally {
        setLoading(false);
      }
    };

    checkProfile();
  }, [user?.email]);

  const handleClick = () => {
    if (user) {
      navigate("/registerprofile"); // logged in → register profile
    } else {
      navigate("/login"); // not logged in → login
    }
  };

  // ✅ Hide button if profile exists
  if (loading || hasProfile) {
    return null;
  }

  return (
    <button className={className} onClick={handleClick}>
      Register Now
    </button>
  );
}
